import React, { useContext, useRef } from 'react';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { useTranslation } from 'react-i18next';
import LocaleContext from '../LocaleContext';

function LangSwitcher(props) {

    const [t, i18n] = useTranslation();

    const lang = useRef("");
    const { locale } = useContext(LocaleContext);

    const switchLang = async () => {
        console.log("lang",lang.current.value);
        let l = lang.current.value;
        if (locale !== l) {
            i18n.changeLanguage(l);
            try {
                await localStorage.setItem("lang", l);
            } catch (error) {
                console.error(error);
            }
        }else{
            console.log("locale is undefined");
        }
    }

    return <Box className={"switcherLang"}>
                <select ref={lang} onChange={switchLang} className="form-control form-select">
                    <option selected={i18n.language == "fr" ? true: false} value="fr">Français</option>
                    <option selected={i18n.language == "en" ? true: false} value="en">English</option>
                </select>
            </Box>;
}

export default LangSwitcher;